import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// Xi application design system — imported last so it can art-direct legacy
// screens without duplicating their styles.
import './styles/xi-app.css';
// Xi redesign layer: tokens, primitives, navigation, homepage, chatbot and
// secondary pages. Loaded after xi-app.css so it owns the final cascade.
import './styles/xi-ui.css';
import { ThemeProvider } from './hooks/useTheme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
